// const rewardRulesOptions = [
//   {
//     value: 0,
//     label: "按固定次数赠送抽奖机会",
//   },
//   {
//     value: 1,
//     label: "按倍数赠送抽奖机会",
//   },
//   {
//     value: 2,
//     label: "按阶梯赠送抽奖机会",
//   },
// ];
const  conditionValue = [13, 4, 9, 10, 11, 12, 16, 17, 18, 20]
const getTaskTypeOptions = (mainText, isShowUnit=true, unit='次')  => {
  return  [
    {
      label: "每日签到",
      value: 1,
      taskCondition: `成功签到，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "浏览店铺",
      value: 2,
      taskCondition: `成功浏览店铺，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "浏览商品",
      value: 13,
      taskCondition: `成功浏览XX件商品，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "加购商品",
      value: 4,
      taskCondition: `成功加购XX件商品，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "分享商品",
      value: 9,
      taskCondition: `成功分享XX件商品，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "分享店铺",
      value: 10,
      taskCondition: `成功分享XX次店铺，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "分享活动",
      value: 11,
      taskCondition: `成功分享XX次活动，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "好友助力",
      value: 8,
      taskCondition: `每邀请1位好友，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间最多完成XX次",
    },
    {
      label: "浏览会场",
      value: 5,
      taskCondition: `成功浏览会场，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间每日最多完成1次",
    },
    {
      label: "预约商品",
      value: 12,
      taskCondition: `每成功预约XX件商品，赠送1${unit}${mainText}机会，最多完成YY次`,
      taskCount: "活动期间最多完成YY次",
    },
    {
      label: "积分兑换",
      value: 16,
      taskCondition: `每xx积分可兑换1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间最多完成YY次",
    },
    {
      label: "购买商品",
      value: 17,
      taskCondition: `完成任务赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间最多完成1次",
    },
    {
      label: "邀请好友入会",
      value: 18,
      taskCondition: `成功邀请XX个好友入会，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: "活动期间最多完成YY次",
    },
    {
      label: "加入会员",
      value: 7,
      taskCondition: "成功加入会员",
      taskCount: "活动期间最多完成1次",
    },
    {
      label: "预售下单",
      value: 20,
      taskCondition: `成功下单并支付定金，每满N件可赠送N${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: `活动期间最多获取N${unit}${mainText}${isShowUnit ? '机会' : ''}`,
    },
    {
      label: "搜索关键词",
      value: 23,
      taskCondition: `成功查询关键词，赠送1${unit}${mainText}${isShowUnit ? '机会' : ''}`,
      taskCount: `活动期间每日最多完成一次`,
    },
  ]
}
const getRewardRulesOptions = (mainText) => {
  return [
    {
      value: 0,
      label: `按固定次数赠送${mainText}`,
    },
    {
      value: 1,
      label: `按倍数赠送${mainText}`,
    },
    {
      value: 2,
      label: `按阶梯赠送${mainText}`,
    },
  ];
};

export {
  getRewardRulesOptions,
  conditionValue,
  getTaskTypeOptions,
}
